import { z } from "zod"

import { PortalRequestResponseSchema } from "./portal.js"

/** What one "Ask the client" did. A repeat click adds nothing and returns
    zeros; `requestId` is null only when there was nothing to ask. */
export const ApiAskTransactionQuestionsResponseSchema = z.object({
  requestId: z.string().uuid().nullable(),
  createdRequest: z.boolean(),
  questionsAdded: z.number().int().nonnegative(),
  rowsAdded: z.number().int().nonnegative(),
  questionsLeft: z.number().int().nonnegative(),
  /** Every request the ask added to. Rows can join an open question on an
      older request than `request`. */
  changedRequestIds: z.array(z.string().uuid()),
  request: PortalRequestResponseSchema.nullable(),
})

export type ApiAskTransactionQuestionsResponse = z.infer<
  typeof ApiAskTransactionQuestionsResponseSchema
>

/** What one accept wrote: the rows that took the category, the question's
    and, under the vendor rule, the vendor's other rows too. */
export const ApiAcceptTransactionQuestionResponseSchema = z.object({
  updatedRows: z.number().int().nonnegative(),
  rulesCreated: z.number().int().nonnegative(),
  request: PortalRequestResponseSchema,
})

export type ApiAcceptTransactionQuestionResponse = z.infer<
  typeof ApiAcceptTransactionQuestionResponseSchema
>

export const ApiAcceptAllTransactionQuestionsResponseSchema = z.object({
  accepted: z.number().int().nonnegative(),
  /** Answered with a note only; those wait for the firm one by one. */
  skipped: z.number().int().nonnegative(),
  request: PortalRequestResponseSchema,
})

export type ApiAcceptAllTransactionQuestionsResponse = z.infer<
  typeof ApiAcceptAllTransactionQuestionsResponseSchema
>
